import * as aws from '@/services/aws';

/**
 * Format service name
 * @param name {string} - Service name
 * @param type {string} - long or short
 * @returns {string} - Formatted service name
 */
export default (name, type = 'long') => {
  if (type === 'long') {
    return aws.long[name] ? aws.long[name] : name;
  }

  if (type === 'short') {
    if (aws.short[name]) {
      return aws.short[name];
    } else if (aws.long[name]) {
      return aws.long[name];
    } else {
      return name;
    }
  }
};
